<div class="flex-centered-container display-flex-column full-height">
    <div class="lottie-container">
        <ng-lottie  [options]="options"></ng-lottie>
    </div>
    <div>Please Wait...</div>
</div>